import * as React from "react";

export const InsideTabGroupContext = React.createContext(false);
